import React from 'react'

const Error = () => {
  return (
    <div className='min-h-screen w-full flex flex-col justify-center gap-4 items-center pt-32 px-6'>
        <h1 className='text-6xl font-DynaPuff text-[#46f8bf] capitalize'>not found</h1>
        <h3 className='text-3xl font-DynaPuff text-white capitalize'>please click on home</h3>
    </div>
  )
}

export default Error